import createReducer from 'arts/config/create_reducer';
import Constants from 'arts/config/constants';

const getDefaultState = () => ({
  filters: null
});

const artFilters = createReducer(getDefaultState(), {
  [Constants.ArtFilters.FETCH_SUCCESS](state, { filters }) {
    return { ...state, filters };
  }
});

export default artFilters;
